module.exports = __webpack_public_path__ + "img/zalora.1d087723.svg";